export const FieldErrors = {
  requiredError: 'Обязательное поле',
  notValid: 'Некорректное значение',
  oneOfError: 'Значение должно быть одним из вариантов',
  personName: 'Необходимо заполнить Фамилию, Имя и Отчество',
  userAgreement: 'Необходимо согласие с условиями',
  advertisingAgreement: 'Необходимо согласие с условиями',
  rejectionAgreement: 'Пожалуйста, поставьте галочку. Без нее мы не сможем показать вам выгодные цены от страховых',
  emptyEmail: 'Введите e-mail',
  notValidEmail: 'Некорректный e-mail',
  requiredData: 'Введите дату',
  birthDateLaterError: 'Не моложе 18 лет',
  birthDateEarlierError: 'Не старше 100 лет',
  futureDateError: 'Дата не может быть в будущем',
  surnameError: 'Укажите фамилию',
  minSymbols: (min: number) => `Не менее ${min} символов`,
  maxSymbols: (max: number) => `Не более ${max} символов`,
  incorrectDocumentObtainingDate: 'Не ранее года выпуска машины',
  incorrectEptsDateStart: 'Дата выдачи ЭПТС не ранее 1 июля 2018 года',
  valuesAreEqual: 'Совпадает с другим полем',
  phonesAreEqual: 'Совпал с другим телефоном в анкете',
  chooseValue: 'Выберите значение',
};
